// import dayjs from 'dayjs';
import Field from '../Field';

// Some of this regex overlaps with dayjs feature set, but some actually extends
const yyyymmdd = /^(\d{4})(?:\/|-|\.)?(0?[1-9]|1[012])(?:\/|-|\.)?(0?[1-9]|[12][0-9]|3[01])$/;
const mmddyyyy = /^(0?[1-9]|1[012])(?:\/|-|\.)?(0?[1-9]|[12][0-9]|3[01])(?:\/|-|\.)?(\d{4})$/;
const ddmmyyyy = /^(0?[1-9]|[12][0-9]|3[01])(?:\/|-|\.)?(0?[1-9]|1[012])(?:\/|-|\.)?(\d{4})$/;
const mmddyy = /^(0?[1-9]|1[012])(?:\/|-|\.)?(0?[1-9]|[12][0-9]|3[01])(?:\/|-|\.)?(\d{2})$/;

// const defaultFormat = 'MM-DD-YYYY';

class DateFormat extends Field {
  sanitize(force = false) {
    super.sanitize(force);

    this.value.forEach((val, index) => {
      if (!force && !this.validIndex[index]) {
        return;
      }

      // const givenDate = dayjs(val);

      // if (givenDate.isValid()) {
      //   const formatted = givenDate.format(defaultFormat);
      //   this.setValue(formatted, index);
      //   this.setDisplayValue(formatted, index);
      //   return this;
      // }

      if (yyyymmdd.test(val)) {
        const matches = val.match(yyyymmdd);
        if (matches && matches[1] && matches[2] && matches[3]) {
          const saneValue = `${matches[2]}-${matches[3]}-${matches[1]}`;
          this.setValue(saneValue, index);
          this.setDisplayValue(saneValue, index);
        }
      } else if (mmddyyyy.test(val)) {
        const matches = val.match(mmddyyyy);
        if (matches && matches[1] && matches[2] && matches[3]) {
          const saneValue = `${matches[1]}-${matches[2]}-${matches[3]}`;
          this.setValue(saneValue, index);
          this.setDisplayValue(saneValue, index);
        }
      } else if (mmddyy.test(val)) {
        const matches = val.match(mmddyy);
        if (matches && matches[1] && matches[2] && matches[3]) {
          const saneValue = `${matches[1]}-${matches[2]}-20${matches[3]}`;
          this.setValue(saneValue, index);
          this.setDisplayValue(saneValue, index);
        }
      } else if (ddmmyyyy.test(val)) {
        const matches = val.match(ddmmyyyy);
        if (matches && matches[1] && matches[2] && matches[3]) {
          const saneValue = `${matches[2]}-${matches[1]}-${matches[3]}`;
          this.setValue(saneValue, index);
          this.setDisplayValue(saneValue, index);
        }
      } else {
        const saneValue = new Intl.DateTimeFormat('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' })
          .format(new Date(val))
          .replace(/\//g, '-');

        this.setValue(saneValue, index);
        this.setDisplayValue(saneValue, index);
      }
    });

    return this;
  }

  validate() {
    super.validate();

    this.value.forEach((val, index) => {
      if (!this.needsValidation(index)) {
        return;
      }

      // Passes Dayjs
      // const givenDate = dayjs(val);
      // if (givenDate.isValid()) {
      //   return;
      // }

      // Passes common regex
      if (!yyyymmdd.test(val) && !mmddyyyy.test(val) && !mmddyy.test(val) && !ddmmyyyy.test(val)) {
        this.invalidate('Invalid date.', index);
      }
    });

    return this.isValid();
  }
}

export default DateFormat;
